import { OndemandVideoOutlined } from "@mui/icons-material";
import { Button, Tooltip } from "@mui/material";

import { useAppState } from "../../../hooks/useAppState";
import { useViewport, View } from "../../Viewport/useViewport";

export default function ButtonExitSlides(): React.ReactElement {
  const { changeView } = useViewport();
  const {
    setSlide,
    appState: { slideId },
  } = useAppState();
  const handleChangeView = () => {
    changeView(View.Video);
    if (slideId) {
      setSlide(slideId);
    }
  };
  return (
    <div style={{ display: "block", position: "absolute", right: 0, bottom: 0 }}>
      <Tooltip title="Change Layout to Video Player">
        <Button
          id="button_exit_slides"
          variant="outlined"
          startIcon={<OndemandVideoOutlined />}
          onClick={handleChangeView}
          tabIndex={1}
        >
          Video
        </Button>
      </Tooltip>
    </div>
  );
}
